var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m159.506 174.357 9.298 51.632 10.054-8.996 30.843 29.784 20.638-21.469-29.256-29.709 9.6-11.112zM74.083 98.99l18.748 88.446m34.396-89.43v89.506m53.748-89.278L165.1 174.357M38.251 67.465l30.314 149.981h98.198m27.479-37.57L216.958 68.22M98.576 37.757V9.03h58.209v28.727M39.31 67.465 53.673 38.74h147.184l16.101 29.482m15.12.53H24.19",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteT);
export default __webpack_public_path__ + "static/media/delete_t.f534c508bdac4b3834d8c8a7d7339d25.svg";
export { ForwardRef as ReactComponent };